import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import H2 from '@base/H2/H2';
import P1 from '@base/P1/P1';
import H3 from '@base/H3/H3';
import ContentsTable from '@base/ContentsTable/ContentsTable';
import MenusNav from '@base/MenusNav/MenusNav';
import { menus } from '@utils/constants';
import { Spacings } from '@styles/index';
import Layout from '@layout/index';
import LeftContainer from '@cont/CompanyDetails/LeftContainer';
import RightContainer from '@cont/CompanyDetails/RightContainer';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 24;
`;

const StyledH3 = styled(H3)`
  margin-bottom: ${Spacings.SPACING_6B};
  padding-top: 100px;
  margin-top: -100px;
`;

const Paragraph = styled(P1)`
  margin-bottom: ${Spacings.SPACING_4B};
  text-align: justify;
`;

const StyledParagraph = styled(Paragraph)`
  margin-bottom: ${Spacings.SPACING_4B};
  ol > li {
    margin-bottom: ${Spacings.SPACING_2B};
    &:first-of-type {
      margin-top: ${Spacings.SPACING_2B};
    }
  }
`;

const ListItem = ({ children }) => (
  <StyledParagraph as="li">{children}</StyledParagraph>
);

const tableData = [
  {
    label: 'A. Eligibility and Participation ',
    id: 'eligibility_and_participation'
  },
  { label: 'B. Personal Information', id: 'personal_information' },
  {
    label: 'C. Consent And Waiver By Participants',
    id: 'consent_and_waiver_by_participants'
  },
  { label: 'D. Rewards', id: 'rewards' },
  { label: 'E. Disclaimers', id: 'disclaimers' }
];

const RankPredictorTerms = () => {
  const router = useRouter();
  const { pathname } = router;

  return (
    <>
      <LeftContainer>
        <MenusNav data={menus} currentHref={pathname} />
      </LeftContainer>

      <RightContainer>
        <Wrapper>
          <div>
            <div>
              <H2 as="h1">UNACADEMY RANK PREDICTOR Terms &amp; Conditions</H2>
            </div>
            <br />
            <br />
            <ContentsTable data={tableData} />
            <Paragraph>
              SORTING HAT TECHNOLOGIES PRIVATE LIMITED (hereinafter referred to
              as “Unacademy”) has a feature called the Rank Predictor
              (“Feature”) available on www.unacademy.com and the Unacademy App
              (hereinafter referred to as “Platform”). This Feature is made
              available to all users who are registered on the Platform
              (“Registered User”). The Feature helps Registered Users to predict
              their ranks for the Exams that they may have attempted or are
              planning to attempt in the near future. The Feature and the
              Registered Users are governed by the terms and conditions hereof
              (“Feature Terms”). The Registered Users shall also continue to be
              governed by the Unacademy Terms and Conditions, Privacy Policy and
              any other policies and guidelines made available on the Platform,
              to the extent applicable (collectively, the “Platform Terms”). All
              capitalized terms not defined herein shall have the meaning
              assigned to it under the Platform Terms. A Registered User may
              choose to actively use the Feature by clicking on any of the
              prompts available on the Platform, and entering the requested
              details on the sign-up page of the Feature, by virtue of which the
              Registered User shall be deemed to be a “Participant” of the
              Feature for all intents and purposes, and shall be bound by, and
              subject to, the terms and conditions hereof. The Feature Terms
              along with the Platform Terms collectively form a legally binding
              agreement between any Participant and Unacademy in respect of use
              of the Feature. By clicking on the “I agree” icon or by submitting
              the sign up to use the Feature, you hereby unconditionally
              consent, agree, and undertake to be bound by and adhere to these
              Platform Terms and Feature Terms. The Feature Terms are, subject
              to modification by Unacademy and shall continue to subsist as
              determined by Unacademy at its sole discretion.
            </Paragraph>
            <br />
            <br />
            <a name={tableData[0].id}>
              <StyledH3>{tableData[0].label}</StyledH3>
            </a>
            <Paragraph>
              The Feature shall be made available to Registered Users who meet
              the eligibility criteria on the Platform Terms, including the Age
              Requirements specified therein. If a Registered User does not meet
              the eligibility criteria or if any of the Platform Terms are not
              acceptable to the Registered User, the Registered User may not
              proceed with using the Feature. All sign-up forms must be
              submitted directly by the Participants and where the Participants
              do not fulfil the Age Requirements, then such sign ups should be
              done with the consent of and under the supervision of their parent
              or legal guardian in accordance with the Platform Terms. To enable
              a Registered User to use the Feature, we may collect some
              information which information may be used for various purposes of
              the Feature including to check and verify the exam results of the
              Participants, reach out to them, offer rewards, etc. For more
              details, please refer the section on “Personal Information” below.
              For best results, as part of the Feature, the Participant may be
              required to undertake a test and/or quiz (“Test”). Unacademy does
              not in any way represent or warrant that the final rank of the
              Participant in the exam will be as predicted in the Feature and
              the final rank of the Participant may be different depending upon
              several factors including the individual performance of the
              Participant in the relevant exam.
            </Paragraph>
            <br />
            <br />
            <a name={tableData[1].id}>
              <StyledH3>{tableData[1].label}</StyledH3>
            </a>
            <Paragraph>
              A Participant’s Personal Information, including Sensitive Personal
              Information, that may be collected to enable them such Participant
              to use the Feature and enable rendering of Services by the
              Platform shall be collected, processed, and stored in accordance
              with the Unacademy’s Privacy Policy. Participants shall have all
              the rights available to them under the applicable Data Protection
              Laws in accordance with the Unacademy Privacy Policy. Unacademy
              shall use a Participant’s Personal Information for facilitating
              this Feature and rendering the Services with respect to the
              Platform in the most effective manner, to secure the Platform and
              make improvements, to perform market research and product
              analysis, to carry out Unacademy’s obligations towards the
              Participant, and to communicate with the Participant. The said
              communication can either be by calls, text, or emails and for the
              purposes of operating the Feature itself, transactional, service,
              advertising or promotional calls or messages about the Feature and
              other offers, new products or services made available by Unacademy
              and the Participant hereby consents to the same. Any deletion
              request received from a Participant in respect of their Personal
              Information shall be processed in accordance with Unacademy
              Privacy Policy. Notwithstanding the foregoing, in the event a
              Participant has already received a reward prior to a deletion
              request / withdrawing consent for use of its information,
              Unacademy shall comply with such request as per the terms of the
              Privacy Policy, subject to the said Participant
              refunding/returning the reward received by such Participant
              pursuant to these Feature Terms.
            </Paragraph>
            <br />
            <br />
            <a name={tableData[2].id}>
              <StyledH3>{tableData[2].label}</StyledH3>
            </a>
            <Paragraph>
              The Participant hereby consents to the use by Unacademy of his/her
              name, age, photograph, videos, voice recordings, rank, statements
              and/or testimonials (“Personal Attributes”) for the purpose of
              publication, advertising, promotion on its online platforms,
              including but not limited to the Platform, and through any mode,
              medium, platform and/or format, including without limitation, in
              newspapers, magazines, other print media, on television, radio,
              internet and other electronic and/or in mailings for educational
              awareness. Any testimonial or statements provided by the
              Participant and any other details pertaining to their use of the
              Platform, content available of the Platform, shall be exclusively
              provided to Unacademy and the Participant warrants to that extent.
              Any marketing material created by Unacademy using a Participant’s
              Personal Attributes shall remain the sole property of Unacademy,
              and the Participant shall have no claim of any nature against the
              same. The Participant understands that the use of his/her Personal
              Attributes by Unacademy shall be made at its sole discretion
              without any further notice to the Participant. Unacademy shall
              have no obligation to consider Participant’s inputs or feedback on
              the use of his/her Personal Attributes. The Participant shall
              release, waive, and discharge claims of any kind or nature arising
              out of or relating to the use of his/her Personal Attributes
              against Unacademy or any person or firm authorized by Unacademy to
              publish the same in accordance with the terms hereof. Such
              release, waiver and discharge shall also extend to all group
              companies, affiliated companies, subsidiaries, shareholders,
              directors, officers, employees, agents and assigns of Unacademy
              and any publishers of the Personal Attributes in accordance with
              the terms hereof. Such a release shall be binding on the
              Participant, his/her respective successors, heirs, assigns,
              executors, administrators, spouse and next of kin. The Participant
              hereby confirms that the chance provided by Unacademy to be
              recognized as a rank-holder in the exam(s) in accordance with
              these Feature Terms, is sufficient consideration for the use of
              Participant’s Personal Attributes by Unacademy in accordance with
              the terms hereof, and Unacademy shall have no liability to pay any
              consideration for any use of the Participant’s Personal Attributes
              in accordance with these Feature Terms.
            </Paragraph>
            <br />
            <br />
            <a name={tableData[3].id}>
              <StyledH3>{tableData[3].label}</StyledH3>
            </a>
            <Paragraph>
              Upon the results of the exam(s) being published, Unacademy may
              check the results of the Participants who have registered for the
              Feature using the information provided, to check / validate the
              ranks of the Participants in such exam(s). Subject to the
              selection parameters and criteria, Unacademy may, at its sole
              discretion, choose to reward Participants who have secured ranks
              in their respective exam(s) (“Rewards”). The Participants
              understands that obtaining a high rank in any exam does not
              automatically qualify them for Rewards under the Feature and
              shortlisting of Participants is based on selection parameters of
              Unacademy, as determined by Unacademy in its sole discretion. The
              shortlisted Participants may be contacted and be required to
              submit additional information / documentation as may be essential
              for Unacademy to provision the Rewards. Unacademy does not accept
              any responsibility for any incorrect and/or incomplete
              communication details provided and/or delay in receipt of
              communication and/or non-receipt of communication. Finally, upon
              collection and verification of the required documentation (as
              required), Rewards shall be processed to the shortlisted
              Participants within timeline as maybe determined by Unacademy at
              its sole discretion. Unacademy shall be well within its rights to
              reject/ the Participant or choose another Participant in place of
              the originally shortlisted Participant if: (a) the documents or
              details provided by the Participant are
              invalid/incorrect/incomplete/ misleading /untrue or not acceptable
              in the opinion of Unacademy; (b) the Participant has not conformed
              to any of the terms and conditions contained herein; (c) the
              Participant does not sign the consent form or any other documents
              required, if any, by Unacademy concerning the Feature; (d) any
              other reason as may be deemed appropriate by Unacademy. The
              process of selection, number of Participants shortlisted for the
              Rewards and the type or form of Reward are to be determined, and
              shall be subject to change, at the sole discretion of Unacademy
              and the decision of Unacademy shall be final and binding. The
              Participants are encouraged to check the Feature Terms and
              Conditions and the Platform Terms on a periodic basis to ensure
              that they do not miss out on any updates and modifications.
            </Paragraph>
            <br />
            <br />
            <a name={tableData[4].id}>
              <StyledH3>{tableData[4].label}</StyledH3>
            </a>
            <ol>
              <ListItem>
                Unacademy and/or its subsidiaries/affiliates shall not be under
                any obligation to the Participant in relation to the Feature and
                the Participant shall have no claims whatsoever against
                Unacademy and/or its subsidiaries/affiliates relating to the
                selection process, gratification, or the running of the Feature.
              </ListItem>
              <ListItem>
                Unacademy shall not be responsible for any errors or omissions
                in the terms and conditions contained herein. All information
                provided is provided “as is” without warranty of any kind. To
                the fullest extent permitted by applicable law, Unacademy
                disclaims all warranties, express or implied, including without
                limitation, implied warranties of merchantability, fitness for a
                particular purpose, and non-infringement in respect of the
                Feature.
              </ListItem>
              <ListItem>
                Unacademy shall have the sole discretion to discontinue/cancel
                the Feature or any part thereof at any point in time and the
                Participant shall not raise any claim due to such
                discontinuation or cancellation at any time whatsoever.
              </ListItem>
              <ListItem>
                Unacademy shall not be held responsible in case of a server
                shutdown or loss of Participant’s registration and/or other
                data. Unacademy shall not be responsible for any delay in
                receipt or non-receipt or incomplete or corrupt receipt of the
                registration or, other details of the Participant. Unacademy
                shall not be responsible for any technical difficulties or data
                corruption that may arise during the registration process.
                Further, Unacademy shall not be responsible and/or liable in any
                manner whatsoever in case the Participant is unable to register
                for participation in the Feature due to failure on part of the
                internet service provider, facility provider, etc.
              </ListItem>
            </ol>
            <br />
            <br />
          </div>
        </Wrapper>
      </RightContainer>
    </>
  );
};

RankPredictorTerms.pageInfo = {
  name: 'Unacademy Rank Predictor Terms',
  isMWebSupported: true,
  layoutOptions: {
    hideGoalSelector: true,
    disableDarkMode: true
  }
};

export default RankPredictorTerms;
RankPredictorTerms.Layout = Layout;
RankPredictorTerms.Wrapper = PageReduxProvider;
